import React, { Component } from "react";
import { trackPage } from "../Container";
import { initDeviceId } from "../device";
import { loginWithFacebook } from "../gateway/LoginGateway";

const FACEBOOK_SIGNIN_STARTED = "/facebook_signin_started";

const NO_RESPONSE = "no response from Facebook";
const UNREGISTERED_USER = "unregistered_user";

export function retrieveUserDetails(fbToken, callback) {
  if (!window.FB) {
    loadFacebookScript(() => {
      window.FB.api("/me", { fields: ["name", "email"] }, callback);
    });
  } else {
    window.FB.api("/me", { fields: ["name", "email"] }, callback);
  }
}

const FB_SCRIPT_ID = "facebook-jssdk";

function loadFacebookScript(cb) {
  ((d, s, id) => {
    const element = d.getElementsByTagName(s)[0];
    const fjs = element;
    let js = element;
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    js.addEventListener("load", () => {
      if (cb && typeof cb === "function") {
        cb();
      }
    });
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", FB_SCRIPT_ID);
}

export default class FacebookButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      email: null,
      fullname: null,
    };

    window.fbAsyncInit = () => {
      window.FB.Event.subscribe("xfbml.render", () => {
        if (this._ismounted) {
          this.setState({ loading: false });
        } else {
          this.state.loading = false;
        }
      });
      window.onFacebookLogin = this.onFacebookSignin.bind(this);
      window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID,
        xfbml: true,
        version: "v9.0",
      });
    };

    if (!document.querySelector(`#${FB_SCRIPT_ID}`)) {
      loadFacebookScript();
    } else {
      window.fbAsyncInit();
      this.state.loading = false;
    }

    if (this.props.facebookToken?.length > 0) {
      this.retrieveUserDetailed(this.props.facebookToken);
    }
  }

  componentDidMount() {
    this._ismounted = true;
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  loginFacebookRequest(deviceId, fbToken) {
    return loginWithFacebook(
      {
        device_id: deviceId,
        access_token: fbToken,
      },
      this.state.clientId
    );
  }

  async tryToSignin(fbToken) {
    return this.loginFacebookRequest(
      await initDeviceId().catch((ex) => console.log(ex)),
      fbToken
    )
      .then((data) => {
        this.props.onChange({ proofToken: data.token });
      }) // for login
      .catch((error) => {
        if (
          error.response?.status === 400 &&
          error.response.data?.error === UNREGISTERED_USER
        ) {
          // Retrieve email and name
          this.retrieveUserDetailed(fbToken);
        } else {
          this.props.onChange({
            error: error.response?.data?.message || NO_RESPONSE,
          });
        }
      });
  }

  retrieveUserDetailed(fbToken) {
    retrieveUserDetails(fbToken, (data) => {
      this.props.onChange({
        facebookToken: fbToken,
        fullname: data?.name,
        email: data?.email,
      });
    });
  }

  onFacebookSignin(x) {
    console.log(x);
    if ((x.status = "connected")) {
      trackPage(FACEBOOK_SIGNIN_STARTED);
      this.tryToSignin(x.authResponse?.accessToken);
    }
  }

  render() {
    return (
      <div className="fb-container center signin-button">
        {this.state.loading && <div className="loader fb-spinner" />}
        <div
          className="fb-login-button"
          data-max-rows="1"
          data-size="large"
          data-width="250px"
          data-button-type="login_with"
          data-scope="public_profile,email"
          data-show-faces="false"
          data-auto-logout-link="false"
          data-use-continue-as="true"
          data-onlogin="onFacebookLogin"
        />
      </div>
    );
  }
}
